import React from "react";

export const CounterRow = props => {
  return <li> {props.data.value}</li>;
};
